<div class="new-hire-modal">
  <div class="modal-header">
    <h2 class="modal-title">
      New Hire Form
      <span class="modal-subtitle" *ngIf="data?.resourceName">— {{ data.resourceName }}</span>
    </h2>
    <button
      type="button"
      mat-icon-button
      class="close-btn"
      aria-label="Close"
      (click)="cancel()"
      [disabled]="saving"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="modal-body" novalidate>
    <!-- Project Name & ID -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Project Name &amp; ID</mat-label>
      <input
        matInput
        formControlName="projectLabel"
        [matAutocomplete]="projectAuto"
        required
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete
        #projectAuto="matAutocomplete"
        [displayWith]="displayProject"
        (optionSelected)="onProjectPicked($event.option.value)"
      >
        <mat-option
          *ngFor="let opt of filteredProjects$ | async"
          [value]="opt"
        >
          {{ opt.projectName }}<span *ngIf="opt.projectIdCode"> | {{ opt.projectIdCode }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- D&T Cost -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>D&amp;T Cost</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput type="number" formControlName="dntCost" step="0.01" />
    </mat-form-field>

    <!-- Vendor Rate Card -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Vendor Rate Card</mat-label>
      <input
        matInput
        formControlName="vendorRateCard"
        [matAutocomplete]="vendorRateCardAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #vendorRateCardAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredVendorRateCards$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Allocation -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Allocation (%)</mat-label>
      <input matInput type="number" formControlName="allocationPct" min="0" max="100" step="1" />
    </mat-form-field>

    <!-- GL BU -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>GL BU</mat-label>
      <input
        matInput
        formControlName="glBusinessUnit"
        [matAutocomplete]="glBusinessUnitAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #glBusinessUnitAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredGlBusinessUnits$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Rate Card Match -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Rate Card Match</mat-label>
      <input
        matInput
        formControlName="rateCardMatch"
        [matAutocomplete]="rateCardMatchAuto"
        maxlength="32"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #rateCardMatchAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredRateCardMatches$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- CAPEX/OPEX -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>CAPEX/OPEX</mat-label>
      <input
        matInput
        formControlName="capexOpex"
        [matAutocomplete]="capexOpexAuto"
        maxlength="32"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #capexOpexAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredCapexOpex$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Bill to FU -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Bill to FU</mat-label>
      <input
        matInput
        formControlName="billToFu"
        [matAutocomplete]="billToFuAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #billToFuAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredBillToFus$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Full HR $ -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Full HR $</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput type="number" formControlName="fullHrAmount" step="0.01" />
    </mat-form-field>

    <!-- PO Type -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>PO Type</mat-label>
      <input
        matInput
        formControlName="poType"
        [matAutocomplete]="poTypeAuto"
        maxlength="32"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #poTypeAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredPoTypes$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Bill to MO -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Bill to MO</mat-label>
      <input
        matInput
        formControlName="billToMo"
        [matAutocomplete]="billToMoAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #billToMoAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredBillToMos$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Hiring Status -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Hiring Status</mat-label>
      <input
        matInput
        formControlName="hiringStatus"
        [matAutocomplete]="hiringStatusAuto"
        required
        maxlength="32"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #hiringStatusAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredHiringStatuses$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Start Date -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" formControlName="billingStartDate" required />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <!-- GL Account -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>GL Account</mat-label>
      <input
        matInput
        formControlName="glAccount"
        [matAutocomplete]="glAccountAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #glAccountAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredGlAccounts$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- End Date -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" formControlName="billingEndDate" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <!-- Tier Model -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Tier Model</mat-label>
      <input
        matInput
        formControlName="tierModel"
        [matAutocomplete]="tierModelAuto"
        maxlength="32"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #tierModelAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredTierModels$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Invoice Location -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      <mat-label>Invoice Location</mat-label>
      <input
        matInput
        formControlName="invoiceLocation"
        [matAutocomplete]="invoiceLocationAuto"
        maxlength="64"
      />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete #invoiceLocationAuto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredInvoiceLocations$ | async" [value]="opt">
          {{ opt }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

  <div class="modal-footer">
    <button
      type="button"
      mat-stroked-button
      class="cancel-btn"
      (click)="cancel()"
      [disabled]="saving"
    >
      Cancel
    </button>
    <button
      type="button"
      mat-flat-button
      class="primary-btn"
      (click)="save()"
      [disabled]="saving"
    >
      <mat-progress-spinner
        *ngIf="saving"
        diameter="16"
        mode="indeterminate"
        class="save-spinner"
      ></mat-progress-spinner>
      <span>{{ saving ? 'Saving...' : 'Save' }}</span>
    </button>
  </div>
</div>
